import React, { useState } from "react";
import { TextField } from "@material-ui/core";

export default function TextFieldTelefone(props) {
//  const [value, setValue] = useState("");

  const formatTelefone = (input) => {
    const numbers = input.replace(/\D/g, ""); // Remove tudo que não for número

    if (numbers.length <= 10) {
      // Telefone fixo (10 dígitos)
      return numbers
        .replace(/^(\d{2})(\d)/, "($1) $2") // DDD
        .replace(/(\d{4})(\d)/, "$1-$2") // Número
        .slice(0, 14);
    } else {
      // Celular (11 dígitos)
      return numbers
        .replace(/^(\d{2})(\d)/, "($1) $2") // DDD
        .replace(/(\d{5})(\d)/, "$1-$2") // Número
        .slice(0, 15);
    }
  };

  const handleChange = (event) => {
    const formatted = formatTelefone(event.target.value);
    //setValue(formatted);

    if (props.onChange) {
      props.onChange({
        ...event,
        target: { ...event.target, value: formatted },
      });
    }
  };

  return (
    <TextField
      {...props}
      value={props.value || ""}
      onChange={handleChange}
      placeholder="(XX) XXXXX-XXXX"
      inputProps={{ maxLength: 15 }} // Define limite máximo de caracteres
    />
  );
}
